import { FocusLock as FocusLockFromChakra } from '@chakra-ui/focus-lock'
import './styles.css'
export const FocusLock = FocusLockFromChakra
